import { useState } from 'react';
import {useDispatch} from 'react-redux';
import {PhoneConfirmation} from '../../../reducers/modals/actions';
import BlueButton from '../../components/blue-button';
import FormInput from '../../components/form-input';
import FormCodeInput from '../../components/form-code';
import ModalsLib from '../../../lib/modals';
import ResendButton from './resend_button';

export default ({data, user}) => {
    const dispatch = useDispatch();

    const [code, setCode] = useState("");

    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Phone confirmation</div>
                    <div className="descriptions">Enter the <b>6-digit</b> confirmation code that has been sent to your <b>{user.phone.value}</b> phone number.</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="form-group">
                    {data.error && (
                        <div class="modal-message warning">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <span dangerouslySetInnerHTML={{__html: data.error}}></span>
                        </div>
                    )}
                    <FormCodeInput onInput={value => setCode(value)} />
                </div>
            </div>

            <div className="modal-footer double">
                <div className="confirmation-buttons">
                    <BlueButton disabled={code.length != 6} active={data.button} onClick={e => {
                        dispatch(PhoneConfirmation.verify(code));
                    }}>
                        Confirm
                    </BlueButton>

                    <div className="button back" onClick={e => {
                        dispatch(PhoneConfirmation.change())
                    }}>
                        Change phone
                    </div>
                </div>
                <ResendButton button={data.resend_button} timestamp={user.phone.timestamp} onClick={e => {
                    dispatch(PhoneConfirmation.resend())
                }} />
            </div>
        </>
    )
}